import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { useParams } from "react-router-dom";

type Props = {
  personId: string;
  status: string;
  enabled: boolean;
};

export const useFetchPersonConducts = ({ personId, status, enabled }: Props) => {
  const { sport, organizationId } = useParams();
  const callApi = useApi();

  return useQuery({
    queryKey: ["conducts", sport, organizationId, personId, status],
    queryFn: () =>
      callApi(`/${sport}/o/${organizationId}/conducts?personId=${personId}&conductStatus=${status}&sortBy=-updated`, {
        defaultErrorMessage: "Can't fetch conducts",
      }),
    enabled,
  });
};
